import React, { useState } from 'react';
import './Accordion.css';

// eslint-disable-next-line react/prop-types
const Accordion = ({ title, content }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="accordion">
      <div className="accordion-header" onClick={toggleAccordion}>
        <b>{title}</b>
        <span className={`icon ${isExpanded ? 'icon-expanded' : 'icon-collapsed'}`}></span>
      </div>
      {isExpanded && <div className="accordion-content">{content}</div>}
    </div>
  );
};

export default Accordion;
